import lazyLoading from "./lazyLoading";
import { allAdminValues } from "../roleDefinitions";

const adminPanelMeta = {
  viewTitle: "Admin Panel",
  auth: {
    roles: allAdminValues,
    forbiddenRedirect: { name: "403" }
  }
};

export const adminRoutes = {
  path: "/admin",
  redirect: { name: "Reporting" },
  name: "Admin",
  component: lazyLoading("Admin"),
  meta: {
    ...adminPanelMeta,
    menuIcon: "admin"
  },
  children: [
    {
      path: "program-stats",
      name: "ProgramStats",
      meta: {
        ...adminPanelMeta,
        linkTitle: "PROGRAM STATS"
      },
      component: lazyLoading("AdminProgramOverview")
    },
    {
      path: "program-center",
      name: "ProgramCenter",
      redirect: { name: "ProgramSettings" },
      meta: {
        ...adminPanelMeta,
        linkTitle: "PROGRAM CENTER"
      },
      component: lazyLoading("ProgramCenter"),
      children: [
        {
          path: "settings",
          name: "ProgramSettings",
          meta: {
            ...adminPanelMeta,
            linkTitle: "PROGRAM SETTINGS"
          },
          component: lazyLoading("ProgramSettings")
        },
        {
          path: "settings/customization",
          name: "ProgramCustomization",
          meta: {
            ...adminPanelMeta,
            linkTitle: "PROGRAM CUSTOMIZATION"
          },
          component: lazyLoading("ProgramCustomization"),
          redirect: { name: "ProgramCustomizationLogo" },
          children: [
            {
              path: "logo",
              name: "ProgramCustomizationLogo",
              meta: {
                ...adminPanelMeta,
                linkTitle: "PROGRAM LOGO"
              },
              component: lazyLoading("ProgramCustomizationLogo")
            },
            {
              path: "navbar-button",
              name: "ProgramCustomizationNavbar",
              meta: {
                ...adminPanelMeta,
                linkTitle: "PROGRAM LOGO"
              },
              component: lazyLoading("ProgramCustomizationNavbar")
            },
            {
              path: "login",
              name: "ProgramCustomizationLogin",
              meta: {
                ...adminPanelMeta,
                linkTitle: "PROGRAM LOGIN"
              },
              component: lazyLoading("ProgramCustomizationLogin")
            }
          ]
        }
      ]
    },
    {
      path: "communications-center",
      name: "CommunicationsCenter",
      meta: {
        ...adminPanelMeta,
        linkTitle: "COMMUNICATIONS"
      },
      component: lazyLoading("CommunicationsCenter")
    },
    {
      path: "member-center",
      name: "MemberCenter",
      meta: {
        ...adminPanelMeta,
        linkTitle: "MEMBERS"
      },
      redirect: { name: "MemberCenterSettings" },
      component: lazyLoading("MemberCenter"),
      scrollBehavior: () => ({ y: 0 }),
      children: [
        {
          path: "settings",
          name: "MemberCenterSettings",
          meta: {
            viewTitle: adminPanelMeta.viewTitle
          },
          component: lazyLoading("MemberCenterSettings")
        },
        {
          path: "settings/member/:id",
          name: "MemberCenterSettingsIndividual",
          props: true,
          meta: {
            viewTitle: adminPanelMeta.viewTitle
          },
          component: lazyLoading("MemberCenterSettingsIndividual")
        }
      ]
    },
    {
      path: "team-center",
      name: "TeamCenter",
      meta: {
        ...adminPanelMeta,
        linkTitle: "TEAMS"
      },
      redirect: { name: "TeamCenterSettings" },
      component: lazyLoading("TeamCenter"),
      scrollBehavior: () => ({ y: 0 }),
      children: [
        {
          path: "teams-settings",
          name: "TeamCenterSettings",
          meta: {
            viewTitle: adminPanelMeta.viewTitle
          },
          component: lazyLoading("TeamCenterSettings")
        },
        {
          path: "teams-settings/teams/:teamId",
          name: "TeamCenterSettingsTeamEdit",
          props: true,
          meta: {
            viewTitle: adminPanelMeta.viewTitle
          },
          component: lazyLoading("TeamEdit")
        },
        {
          path: "create-multiple-teams",
          name: "TeamCenterSettingsCreateMultipleTeams",
          props: true,
          meta: {
            viewTitle: adminPanelMeta.viewTitle
          },
          component: lazyLoading("CreateMultipleTeams")
        },
        {
          path: "organizations-settings",
          name: "OrganizationsCenter",
          meta: {
            ...adminPanelMeta,
            linkTitle: "ORGANIZATIONS"
          },
          redirect: { name: "OrganizationsCenterSettings" },
          component: lazyLoading("OrganizationsCenterSettings"),
          children: [
            {
              path: "",
              name: "OrganizationsCenterSettings",
              meta: {
                viewTitle: adminPanelMeta.viewTitle
              },
              component: lazyLoading("OrganizationsCenterSettings")
            }
          ]
        }
      ]
    },
    {
      path: "challenge-center",
      name: "ChallengeCenter",
      meta: {
        ...adminPanelMeta,
        linkTitle: "CHALLENGES"
      },
      redirect: { name: "ChallengeCenterSettings" },
      component: lazyLoading("ChallengeCenter"),
      children: [
        {
          path: "settings",
          name: "ChallengeCenterSettings",
          meta: {
            viewTitle: adminPanelMeta.viewTitle
          },
          component: lazyLoading("ChallengeCenterSettings")
        },
        {
          path: "builder/:mode?",
          name: "ChallengeCenterBuilder",
          props: true,
          meta: {
            viewTitle: adminPanelMeta.viewTitle
          },
          component: lazyLoading("ChallengeCenterBuilder")
        },
        {
          path: "challenge-edit/:challengeId",
          name: "ChallengeEditAdmin",
          props: true,
          meta: {
            viewTitle: adminPanelMeta.viewTitle
          },
          component: lazyLoading("ChallengeEdit")
        },
        {
          path: "maps-center/builder",
          name: "MapCenterBuilder",
          props: true,
          meta: {
            viewTitle: adminPanelMeta.viewTitle
          },
          component: lazyLoading("MapCenterBuilder")
        }
      ]
    },
    {
      path: "features",
      name: "FeaturesSettings",
      meta: {
        ...adminPanelMeta,
        linkTitle: "FEATURES SETTINGS"
      },
      component: lazyLoading("FeaturesSettings")
    },
    {
      path: "reporting",
      name: "Reporting",
      meta: {
        ...adminPanelMeta,
        linkTitle: "REPORTING"
      },
      component: lazyLoading("StatsReporting")
    },
    {
      path: "help-center",
      name: "HelpCenter",
      meta: {
        ...adminPanelMeta,
        linkTitle: "HELP"
      },
      component: lazyLoading("HelpCenter")
    }
  ]
};

export default adminRoutes;
